import { createContext } from 'react';

const AlignmentContext = createContext();

AlignmentContext.displayName = 'AlignmentContext';

export default AlignmentContext;
